export const MembershipIcon = ({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) => (
  <svg height="36" viewBox="0 0 36 36" fill="none" className={className}>
    <path
      d="M29 9H32C33.6569 9 35 10.3431 35 12V30C35 31.6569 33.6569 33 32 33H4C2.34315 33 1 31.6569 1 30V12C1 10.3431 2.34315 9 4 9H7"
      stroke="#8746EC"
      strokeWidth="1.8"
      strokeLinecap="round"
      className={pathClassName}
    />
    <path
      d="M11.6 18.8539C12.0821 19 12.7332 19 13.84 19H22.16C23.2668 19 23.9179 19 24.4 18.8539M11.6 18.8539C11.4967 18.8226 11.4011 18.7846 11.3104 18.7384C10.8588 18.5083 10.4917 18.1412 10.2616 17.6896C10 17.1762 10 16.5041 10 15.16V6.84C10 5.49587 10 4.82381 10.2616 4.31042C10.4917 3.85883 10.8588 3.49168 11.3104 3.26158C11.8238 3 12.4959 3 13.84 3H22.16C23.5041 3 24.1762 3 24.6896 3.26158C25.1412 3.49168 25.5083 3.85883 25.7384 4.31042C26 4.82381 26 5.49587 26 6.84V15.16C26 16.5041 26 17.1762 25.7384 17.6896C25.5083 18.1412 25.1412 18.5083 24.6896 18.7384C24.5989 18.7846 24.5033 18.8226 24.4 18.8539M11.6 18.8539C11.6003 18.2065 11.6042 17.8639 11.6615 17.5757C11.914 16.3063 12.9063 15.314 14.1757 15.0615C14.4848 15 14.8566 15 15.6 15H20.4C21.1434 15 21.5152 15 21.8243 15.0615C23.0937 15.314 24.086 16.3063 24.3385 17.5757C24.3958 17.8639 24.3997 18.2065 24.4 18.8539M21.2 9C21.2 10.7673 19.7673 12.2 18 12.2C16.2327 12.2 14.8 10.7673 14.8 9C14.8 7.23269 16.2327 5.8 18 5.8C19.7673 5.8 21.2 7.23269 21.2 9Z"
      stroke="#8746EC"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
    <path
      d="M6 24H30"
      stroke="#8746EC"
      strokeWidth="1.8"
      strokeLinecap="round"
      className={pathClassName}
    />
    <path
      d="M13 28L24 28"
      stroke="#8746EC"
      strokeWidth="1.8"
      strokeLinecap="round"
      className={pathClassName}
    />
  </svg>
);
